/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc
 */
import * as References from './AppRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc#listSupportedApps
 */
export const LIST_SUPPORTED_APPS_QUERY_FIELD_NAME =
  'com_hubspot_unifiedaccount_rpc_AppRpc_listSupportedApps';
export const LIST_SUPPORTED_APPS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.ListSupportedAppsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_SUPPORTED_APPS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListSupportedAppsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listSupportedAppsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc#getSupportedApp
 */
export const GET_SUPPORTED_APP_QUERY_FIELD_NAME =
  'com_hubspot_unifiedaccount_rpc_AppRpc_getSupportedApp';
export const GET_SUPPORTED_APP_QUERY: RegisteredQuery<
  'result',
  References.GetSupportedAppRequestType,
  References.GetSupportedAppResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SUPPORTED_APP_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetSupportedAppRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSupportedAppResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSupportedAppRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
